import { gsap, Power3, Power2 } from "gsap";

import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';

class ScrollItem__Image extends VScroll_Item {
  img;
  figure;
  imgHeight = 0;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.figure = GetBy.selector('figure', __link)[0];
    this.wrapper = GetBy.class('img', __link)[0];

    this.img = GetBy.selector('img', __link)[0];
    if (!this.img) this.img = GetBy.selector('video', __link)[0];

    // gsap.set(this.figure, { height: 0 });
    // gsap.set(this.img, { scale: 1.5, filter: 'blur(10px)' });
    gsap.set(this.img, { filter: 'blur(10px)', opacity: 0 });

    this.onShow = () => {
      // gsap.killTweensOf(this.figure);
      // gsap.to(this.figure, {
      //   height: '100%',
      //   duration: 1.4,
      //   ease: Power3.easeOut
      // });

      gsap.killTweensOf(this.img);
      // gsap.to(this.img, { scale: 1, duration: 1.8, ease: Power2.easeOut, delay: .15 * this.index });
      // gsap.to(this.img, { filter: 'blur(0px)', duration: .6, ease: Power3.easeOut, delay: .15 * this.index });
      gsap.to(this.img, { filter: 'blur(0px)', opacity: 1, duration: .8, ease: Power2.easeOut });
    };

    this.onHide = () => {
      // this.figure.style.top = 0;
      // this.figure.style.bottom = 'auto';

      // gsap.killTweensOf(this.figure);
      // gsap.to(this.figure, {
      //   height: 0,
      //   duration: .6,
      //   ease: Power3.easeOut,
      //   onComplete: () => {
      //     this.isShown = false;
      //   }
      // });

      gsap.killTweensOf(this.img);
      // gsap.to(this.img, { scale: 1.5, duration: .6, ease: Power2.easeOut });
      // gsap.to(this.img, { filter: 'blur(10px)', duration: .4, ease: Power3.easeOut });
      gsap.to(this.img, { filter: 'blur(10px)', opacity: 0, duration: .3, ease: Power2.easeOut });
    };
  }

  resize() {
    super.resize();

    const { height } = this.wrapper.getBoundingClientRect();
    this.img.style.height = height + 'px';
  }
}

Scroll._registerClass('Image', ScrollItem__Image);
